const initMobileMenu = (header, mobileMenuState) => {
  const mobileMenu = header.querySelector('.mobile-menu');
  const burgerBtn = header.querySelector('.burger-btn');
  const closeMobMenuBtn = header.querySelector('.close-menu-btn');

  const openMobileMenu = () => {
    mobileMenu.classList.add('show', 'showAnim');
    header.classList.add('mob-menu-open');
    document.documentElement.classList.add('lock-scroll');
    mobileMenuState.isOpened = true;
  };

  const closeMobileMenu = () => {
    mobileMenu.classList.add('hideAnim');
    header.classList.remove('mob-menu-open');
    document.documentElement.classList.remove('lock-scroll');
    mobileMenuState.isOpened = false;

    setTimeout(() => {
      mobileMenu.classList.remove('show', 'showAnim', 'hideAnim');
    }, 350);
  };

  const closeMobileMenuOnOutsideClick = (e) => {
    if (!e.target.closest('header')) {
      mobileMenu.classList.add('hideAnim');
      document.documentElement.classList.remove('lock-scroll');
      mobileMenuState.isOpened = false;

      setTimeout(() => {
        mobileMenu.classList.remove('show', 'showAnim', 'hideAnim');
      }, 350);
    }
  };

  burgerBtn.addEventListener('click', openMobileMenu);
  closeMobMenuBtn.addEventListener('click', closeMobileMenu);
  document.addEventListener('click', (e) => closeMobileMenuOnOutsideClick(e));
};

export { initMobileMenu };
